import { render, staticRenderFns } from "./AppBatchUpdate.vue?vue&type=template&id=d8007bf6&scoped=true"
import script from "./AppBatchUpdate.vue?vue&type=script&lang=js"
export * from "./AppBatchUpdate.vue?vue&type=script&lang=js"
import style0 from "./AppBatchUpdate.vue?vue&type=style&index=0&id=d8007bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8007bf6",
  null
  
)

export default component.exports